import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CardInfo from './components/CardInfo';
import PaymentInfo from './components/PaymentInfo';
import PurchaseAgreements from './components/PurchaseAgreements';
import PurchaseButton from './components/PurchaseButton';
import Summary from './components/Summary';
import useInitialValues from './hooks/useInitialValues';

interface Params {
    prepaidCardImageId: string;
    cardName?: string;
    amount?: number;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardImageActivity: Params;
    }
}

const PrepaidCardImageActivity: ActivityComponentType<'PrepaidCardImageActivity'> = ({ params }) => {
    const { t } = useTranslation('prepaidCard');
    const { prepaidCardImageId, cardName, amount } = params;
    useInitialValues({ cardName, amount });

    return (
        <AppScreen>
            <CtaLayout header={<Header title={t('image.title')} />}
                footer={<PurchaseButton prepaidCardImageId={prepaidCardImageId} />}>
                <Column fullWidth>
                    <Summary prepaidCardImageId={prepaidCardImageId} />
                    <Divider />
                    <CardInfo />
                    <Divider/>
                    <PaymentInfo />
                    <Divider/>
                    <PrepaidCardNotes types={['USAGE']} noMargin />
                    <PurchaseAgreements />
                </Column>
            </CtaLayout>
        </AppScreen>
    );
};

export default PrepaidCardImageActivity;
